import { addDays } from 'date-fns';
import { Link } from 'react-router';
import {
  getPeriodEndAt,
  getWeekStartAt,
  toFullDayDateString,
} from '@/utils/datetime';

interface WeekNavigationForQuarterProps {
  quarterStartAt: Date;
}

export function WeekNavigationForQuarter({
  quarterStartAt,
}: WeekNavigationForQuarterProps) {
  const quarterEndExclusive = getPeriodEndAt(quarterStartAt, 'quarter');
  const thisWeekStartAt = getWeekStartAt(new Date());
  const lastWeekStartAt = addDays(thisWeekStartAt, -7);
  const nextWeekStartAt = addDays(thisWeekStartAt, 7);
  const finalWeekStartAt = addDays(quarterEndExclusive, -7);

  const isInQuarter = (date: Date) =>
    date >= quarterStartAt && date < quarterEndExclusive;

  function getRelevantWeeks(): Array<{ date: Date; label: string }> {
    const currentWeekInQuarter = isInQuarter(thisWeekStartAt);

    return [
      {
        date: lastWeekStartAt,
        label: 'Last week',
        condition: currentWeekInQuarter && isInQuarter(lastWeekStartAt),
      },
      {
        date: thisWeekStartAt,
        label: 'This week',
        condition: currentWeekInQuarter,
      },
      {
        date: nextWeekStartAt,
        label: 'Next week',
        condition: currentWeekInQuarter && isInQuarter(nextWeekStartAt),
      },
      {
        date: quarterStartAt,
        label: 'First week',
        condition: !currentWeekInQuarter,
      },
      {
        date: finalWeekStartAt,
        label: 'Final week',
        condition: !currentWeekInQuarter,
      },
    ]
      .filter(({ condition }) => condition)
      .map(({ date, label }) => ({ date, label })); // remove condition property
  }

  return (
    <div className="flex gap-1">
      {getRelevantWeeks().map(({ date, label }, index) => (
        <Link
          key={index}
          to={`/week/${toFullDayDateString(date)}`}
          aria-label={label}
          className="border-muted-background hover:bg-muted flex h-7 items-center justify-center rounded border px-2 text-[13px] hover:text-black"
        >
          {label}
        </Link>
      ))}
    </div>
  );
}
